/*
 * The form is a region *inside* the deals panel rather than a page of its own: a founder is
 * filing one of their own deals and then watches it move through review on the same panel.
 *
 * It draws no separator of its own. Whether one is needed depends on what is above it —
 * nothing, for a founder with no deals; a list of cards, for a founder adding another — so
 * that decision belongs to the container placing it (`DealsPanel.module.css`), not here.
 */
.submit {
  display: grid;
  gap: var(--space-5);
}

.heading {
  font-family: var(--font-display);
  font-size: var(--text-lg);
}

/* Focus lands here when the form is opened from the deals list; the ring is what tells a
   keyboard user they were moved, so it must be visible even though the heading is not
   otherwise interactive. */
.heading:focus-visible {
  outline: 2px solid var(--focus);
  outline-offset: 4px;
  border-radius: var(--radius-sm);
}

.guidance {
  display: grid;
  gap: var(--space-4);
}

.lede {
  color: var(--text);
  font-size: var(--text-base);
  max-inline-size: var(--measure);
}

/*
 * Mobile-first: the two guides stack, and sit side by side once there is room for both to
 * keep a readable measure. They are the answer to "will this be listed?", so they precede
 * the boxes rather than sitting beside them where they could be scrolled past.
 */
.guides {
  display: grid;
  gap: var(--space-4);
}

@media (min-width: 44rem) {
  .guides {
    grid-template-columns: 1fr 1fr;
    gap: var(--space-5);
  }
}

.guide {
  display: grid;
  gap: var(--space-2);
  align-content: start;
  padding-inline-start: var(--space-4);
  border-inline-start: 3px solid var(--brass-rule);
  color: var(--text-muted);
  font-size: var(--text-sm);
}

.guideTitle {
  font-family: var(--font-display);
  font-size: var(--text-base);
  color: var(--text);
}

.checks {
  display: grid;
  gap: var(--space-1);
  list-style: disc;
  padding-inline-start: var(--space-4);
}

.form {
  display: grid;
  gap: var(--space-5);
}

.fields {
  display: grid;
  gap: var(--space-4);
}

/*
 * The two prices are one fact read together — a before and an after — so they sit side by
 * side as soon as there is room, and stack on a phone rather than shrinking below a usable
 * target.
 */
.pair {
  display: grid;
  gap: var(--space-4);
}

@media (min-width: 40rem) {
  .pair {
    grid-template-columns: 1fr 1fr;
  }
}

/*
 * The consent block is set apart from the fields above it: it is the one control that is not
 * a description of the deal but a statement about the founder, and it is what core records.
 */
.terms {
  display: grid;
  gap: var(--space-2);
  padding: var(--space-4);
  border: 1px solid var(--border);
  border-radius: var(--radius-md);
  background: var(--surface);
}

.version {
  color: var(--text-muted);
  font-size: var(--text-xs);
}

.actions {
  display: flex;
  flex-wrap: wrap;
  gap: var(--space-3);
}

.failure {
  display: grid;
  gap: var(--space-2);
  padding: var(--space-4);
  border: 1px solid var(--danger);
  border-radius: var(--radius-md);
  color: var(--text);
  font-size: var(--text-sm);
}

.issues {
  display: grid;
  gap: var(--space-1);
  list-style: disc;
  padding-inline-start: var(--space-5);
  color: var(--text-muted);
}
